/* KW 3.0 — keep the buy box in step with the subscription widget.

   Seal (and any other subscription app) renders its own radios and then writes
   a selling_plan input into the product form. It does not touch the theme's
   price, its add-to-cart label or its delivery note, so without this the page
   shows £38.25 in the widget and £45.00 on the button — which reads as broken
   and costs the sale.

   Prices come from Liquid, not from scraping the widget: the section renders
   variant.selling_plan_allocations as a plan-id -> price map, so the number on
   the button is Shopify's own and cannot drift from what checkout charges.

   The map and the base price are read from the dataset on every sync rather
   than cached at init, because kw-variants.js rewrites both when the customer
   changes tier. kw:variant is that file's signal that they have.

   The delivery note swaps too. Free shipping on subscriptions is a real
   benefit and it was invisible — worse, the note said "over £50" while a
   subscriber gets it regardless.

   The input is usually hidden and set programmatically, which fires no change
   event, so a MutationObserver does the real work and the change and click
   listeners are belt and braces. */

(function () {
  function init(root) {
    if (!root || root.dataset.kwPlanReady === '1') return;

    var form = root.querySelector('form[action*="/cart/add"]');
    var priceEl = root.querySelector('[data-kw-price]');
    var ctaEl = root.querySelector('[data-kw-cta]');
    if (!form || !ctaEl) return;

    root.dataset.kwPlanReady = '1';

    var label = ctaEl.dataset.kwCta || 'Add to basket';
    var fmt = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: root.dataset.kwCurrency || 'GBP'
    });

    var shipEl = root.querySelector('[data-kw-ship]');
    var shipOne = shipEl ? shipEl.innerHTML : null;
    var shipSub = shipEl ? shipEl.getAttribute('data-kw-ship-sub') : null;

    var last = null;

    function plans() {
      try { return JSON.parse(root.dataset.kwPlans || '{}'); } catch (e) { return {}; }
    }

    function currentPlan() {
      var checked = form.querySelector('[name="selling_plan"]:checked');
      if (checked) return checked.value;
      var single = form.querySelector('[name="selling_plan"]');
      return single ? single.value : '';
    }

    function sync(force) {
      var id = currentPlan();
      if (id === last && !force) return;
      last = id;

      var map = plans();
      var onPlan = !!(id && Object.prototype.hasOwnProperty.call(map, id));

      /* No plan selected: kw-variants.js already owns the price line, so
         leave it alone rather than fighting it with a stale base. */
      if (!onPlan) {
        if (shipEl && shipSub) shipEl.innerHTML = shipOne;
        return;
      }

      var price = map[id];
      if (priceEl) priceEl.textContent = fmt.format(price / 100);

      var span = ctaEl.querySelector('span');
      if (span) span.textContent = label + ' — ' + fmt.format(price / 100);

      if (shipEl && shipSub) shipEl.innerHTML = '<p>' + shipSub + '</p>';
    }

    form.addEventListener('change', function () { sync(false); });
    form.addEventListener('click', function () { setTimeout(function () { sync(false); }, 60); });
    root.addEventListener('kw:variant', function () { sync(true); });

    if (window.MutationObserver) {
      new MutationObserver(function () { sync(false); }).observe(form, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['value', 'checked']
      });
    }

    sync(true);
  }

  function boot() {
    document.querySelectorAll('[data-kw-plans]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();